import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getReports = ({ groupId, reportIds }) =>
  call(websocketFetch, 'get_reports', {
    group_id: groupId,
    report_ids: reportIds,
  });
